import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { ButtonBase } from "@mui/material";
import useFetch from "../../../utils/useFetch";
import axios from "../../../utils/fvAxios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";

export default function EditTraningMoodle({ users, courses, moodles,close,REFRESH,SetREFRESH}) {
  const [data, setData] = useState([ ]);
  const [getMoodleEmployeeQuizCategorie, setGetMoodleEmployeeQuizCategorie] =
    React.useState([]);
  const [getMoodleEmployeeQuizCategorie1, setGetMoodleEmployeeQuizCategorie1] =
    React.useState([]);

    const [getMoodleEmployee, setGetMoodleEmployee] =
    React.useState([]);
 
  const { data: res } = useFetch(
    "Employee/GetMoodleEmployeeQuizCategories?empId=" +
      users +
      "&courseId=" +
      courses +
      "&isMoodleCourse=" +
      moodles
  );
  useEffect(() => {
    if (res?.data) {
      setData(res?.data);
    }
  }, [res]);
  const Save = async () => {
    const defaultAttachmentsLists = getMoodleEmployeeQuizCategorie1?.map(
      (r) => {
        return {
          "empQuizCategoryId": r?.empQuizCategoryId,
          "categoryName": r?.categoryName,
          "categoryType": r?.categoryType,
          "subCategoryControlType": r?.subCategoryControlType,
          "subCategoriesValue": r?.subCategoriesValue,
          "subCategoryEnteredDate": r?.subCategoryEnteredDate? moment(r?.subCategoryEnteredDate)?.utc() :null,
          "subCategorySelectedValue": r?.subCategorySelectedValue,
          "sysUserOrgId": r?.sysUserOrgId,
          "sysUserOrgQuizId": r?.sysUserOrgQuizId,
        };
      }
    );
    setGetMoodleEmployee(defaultAttachmentsLists)
    const Default = JSON.stringify(defaultAttachmentsLists);
    axios
      .post(
        "Employee/PostMoodleEmployeeQuizCategories",
        Default,
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((res) => {
        if (res?.data?.responseCode == 100) {
          toast.success(res?.data?.data, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          SetREFRESH(!REFRESH);
        } else {
          toast.error(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
     
      close();
     
  };
   
  const handleSubCategoryChange = (event, index, property) => {
    const newData = [...data];
    newData[index][property] = event?.target?.value;
  
    // check if subCategoryEnteredDate has a value
    if (newData[index].subCategoryEnteredDate) {
      const enteredDate = new Date(newData[index]?.subCategoryEnteredDate);
      newData[index].subCategoryEnteredDate = enteredDate;
      // assign the enteredDate as the default value for DatePicker
      newData[index].defaultDate = enteredDate;
    } else {
      newData[index].defaultDate = null;
    }
  
    setData(newData);
    setGetMoodleEmployeeQuizCategorie1(data);
  };
  return (
    <>
      <DialogTitle id="alert-dialog-title">
        {"Edit Employee Training Category"}
      </DialogTitle>
      <ToastContainer />
      <DialogContent>
        {/* {getMoodleEmployeeQuizCategorie?.map((r) => (
          <div key={r.empQuizCategoryId}>
            <span>{r.categoryName} </span>
            <br />
            <FormControl fullWidth>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={age == "" ? r.subCategorySelectedValue : age}
                style={{ marginBottom: "10px" }}
                onChange={(event) => {
                  handleChange(event.target.value, r.empQuizCategoryId, 2);
                  setAge(event.target.value)
                }}
              
                size="small"
              >
                {r.subCategoriesValue.split("|").map((menu) => (
                  <MenuItem key={menu} value={menu}>
                    {menu}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <br />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DesktopDatePicker
                inputFormat="MM/DD/YYYY"
                value={value}
                onChange={(event) => {
                  handleChange(event.$d, r.empQuizCategoryId, 1);
                  setValue(event.$d);
                }}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    style={{ marginBottom: "10px" }}
                    {...params}
                  />
                )}
              />
            </LocalizationProvider>
          </div>
        ))} */}
        {data?.map((item, index) => (
      <div key={item?.empQuizCategoryId}>
        <span style={{color:"#3E4A62",fontSize:"14px",fontWeight:"500",marginTop:"5px",marginBottom:"5px"}}>{item?.categoryName}</span>
        <br />
        <Select
        size='small'
          sx={{width:"281px"}}
          value={item?.subCategorySelectedValue}
          onChange={(event) => handleSubCategoryChange(event, index, 'subCategorySelectedValue')}
        >
          {item?.subCategoriesValue?.split('|')?.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
        <br />
        {item?.subCategorySelectedValue !== 'N/A' && item?.subCategorySelectedValue !== null && (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
          
            value={item?.subCategoryEnteredDate}
            defaultValue={item?.defaultDate}
            onChange={(date) => handleSubCategoryChange({target: {value: date}}, index, 'subCategoryEnteredDate')}
            renderInput={(params) => <TextField {...params}   sx={{width:"281px",marginTop:"10px"}} size='small'/>}
          />
        </LocalizationProvider>
            )}
      </div>
    ))}
        <br />
        <DialogActions>
          <div className="login-help__buttonContainer">
            <Button variant="contained" className="login-help-button-cancel" onClick={close}>
              Cancel
            </Button>
            <Button
              variant="contained"
              className="login-button-request"
              onClick={Save}
            >
              Save
            </Button>
          </div>
        </DialogActions>
      </DialogContent>
    </>
  );
}